import { render } from "./TrashcanIcon.vue?vue&type=template&id=335de4ad"
import script from "./TrashcanIcon.vue?vue&type=script&lang=js"
export * from "./TrashcanIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__